<template>
  <div class="row">
    <div class="col-md-6">
      <vs-button icon="refresh" color="dark" @click="refreshDataHandler" class="mb-2">
        Actualizar
      </vs-button>

      <vs-table :data="interestTrxs" stripe>
        <template slot="thead">
          <vs-th>Id</vs-th>
          <vs-th>Tipo trx</vs-th>
          <vs-th>Monto</vs-th>
          <vs-th>Concepto</vs-th>
          <vs-th>F. de creación</vs-th>
          <vs-th>Opciones</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr v-for="item in data">
            <vs-td>
              <span @click="interestTrxSelectedHandler(item)" class="underline cursor-pointer">
                {{ item.id }}
              </span>
            </vs-td>
            <vs-td>{{ item.trx_type }}</vs-td>
            <vs-td>{{ item.amount }}</vs-td>
            <vs-td>{{ item.concept }}</vs-td>
            <vs-td>{{ item.created_at }}</vs-td>
            <vs-td>
              <vs-button
                v-if="item.retentions.length === 0"
                @click="generateInterestTrx(item)"
                color="dark"
                icon="send"></vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
    <div class="col-md-6">
      <vs-table :data="interestTrxSelected.retentions" stripe class="mt-12">
        <template slot="thead">
          <vs-th>Id</vs-th>
          <vs-th>Tipo trx</vs-th>
          <vs-th>Monto</vs-th>
          <vs-th>Concepto</vs-th>
          <vs-th>F. de creación</vs-th>
          <vs-th>Opciones</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr v-for="item in data">
            <vs-td>{{ item.id }}</vs-td>
            <vs-td>{{ item.trx_type }}</vs-td>
            <vs-td>{{ item.amount }}</vs-td>
            <vs-td>{{ item.concept }}</vs-td>
            <vs-td>{{ item.created_at }}</vs-td>
            <vs-td>
              <vs-button
                @click="openUrl(item)"
                color="dark"
              >
                Dispersar
              </vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
  </div>
</template>
<script>
export default {
  name: "RetentionTrxGenerator",
  props: {
    interestTrxIds: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    interestTrxSelected: {retentions: []},
    interestTrxs: []
  }),
  async mounted() {
    await this.getRetentionData();
    // si todos los intereses tiene sus retenciones ir al siguiente tab
    if (this.allRetentionHasRetention()) {
      this.$emit('onSuccess');
    }
  },
  methods: {
    allRetentionHasRetention() {
      for (let item of this.interestTrxs) {
        if (item.retentions.length === 0) {
          return false;
        }
      }
      return false;
    },
    async refreshDataHandler() {
      await this.getRetentionData();
    },
    async getRetentionData() {
      this.$vs.loading();
      try {
        const {data} = await axios.post('/api/billing/trx/retention', {
          interestTrxIds: this.interestTrxIds
        })
        this.interestTrxs = data;
      } finally {
        this.$vs.loading.close();
      }
    },
    interestTrxSelectedHandler(item) {
      this.interestTrxSelected = item;
    },
    openUrl(item) {
      window.open(`/cobranza/${item.project_id}`, '_blank');
    },
    async generateInterestTrx(item) {
      this.$vs.loading();
      try {
        await axios.post('/api/billing/trx/retention/generate', {
          interestTrxId: item.id
        })

        await this.getRetentionData();
      } finally {
        this.$vs.loading.close();
      }
    }
  }
}
</script>
<style scoped>

</style>